/* SELVA — polish (15.-16. sept 2026)
   1) Scroll-reveal paa de egne SELVA-sektioner.
   2) Prisretning i koebsboksen paa produkter uden abonnement.
   3) Haartype-valget skifter hovedbilledet i galleriet (20. sept 2026).
   4) Indlaeser galleri-navigationen: pile og swipe (21. sept 2026).

   Elementerne bliver foerst skjult naar dette script koerer, saa en fejl
   her kan ikke give en blank side. En sikkerheds-timer viser alt igen
   efter 2,5 sekunder, hvis noget mod forventning ikke naaede at blive
   observeret. */
(function () {
  if (window.__selvaPolish) return;
  window.__selvaPolish = true;

  /* =========================================================
     1) SCROLL-REVEAL
     ========================================================= */
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var SEL = [
    '[id^="sms-"] .sms__title', '[id^="sms-"] .sms__body', '[id^="sms-"] .sms__media',
    '[id^="sfd-"] .sfd__title', '[id^="sfd-"] .sfd__lead', '[id^="sfd-"] .sfd__media', '[id^="sfd-"] .sfd__punkt',
    '[id^="sud-"] .sud__title', '[id^="sud-"] .sud__lead', '[id^="sud-"] .sud__list', '[id^="sud-"] .sud__media',
    '[id^="ssr-"] .ssr__head', '[id^="ssr-"] .ssr__scroll',
    '[id^="shg-"] .shg__head', '[id^="shg-"] .shg__card',
    '[id^="skr-"] .skr__title', '[id^="skr-"] .skr__viewport',
    '[id^="srg-"] .srg__head', '[id^="srg-"] .srg__card',
    '[id^="ssc-"] .ssc__inner'
  ].join(",");

  function startReveal() {
    if (reduce || !("IntersectionObserver" in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (!els.length) return;

    // Lille forskydning inden for hver sektion, saa tingene lander efter hinanden.
    var talt = {};
    els.forEach(function (el) {
      var sec = el.closest ? el.closest(".shopify-section") : null;
      var key = sec ? sec.id : "løs";
      talt[key] = (talt[key] || 0) + 1;
      var trin = Math.min(talt[key] - 1, 5);
      el.style.transitionDelay = trin * 70 + "ms";
      el.classList.add("selva-reveal");
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

    els.forEach(function (el) { io.observe(el); });

    // Sikkerhedsnet.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add("is-in"); });
    }, 2500);
  }

  /* =========================================================
     2) PRISRETNING PAA PRODUKTER UDEN ABONNEMENT

     FEJL i selva-produkt-koeb: sektionens state starter altid paa
     koebstype "abonnement", og pakkepriserne tegnes som variantens pris
     gange 0,9. Paa produkter der rent faktisk HAR abonnement er det
     rigtigt. Men paa produkter uden — vatpinde, picks, pads, tabletter,
     udskiftningshoveder, el-tandboersten — findes koebstype-vaelgeren
     slet ikke, staten bliver staaende paa "abonnement", og saa viste
     kortene 10% under den pris kunden faktisk bliver opkraevet. Selve
     koebet var korrekt (linjen der saetter selling_plan kraever ogsaa
     frekvensknapper), saa det var kun den viste pris der loej. Det er
     stadig en prisoplysningsfejl, saa den skal vaek.

     Her rettes de tegnede priser tilbage til variantens rigtige pris.
     Kun i sektioner UDEN koebstype-vaelger — tandboersten og
     tungeskraberen roeres ikke. Variantpriserne laeses fra sektionens
     egen JSON-blok, saa der ikke regnes paa noget opdigtet.
     ========================================================= */
  function formatDkk(oere) {
    if (window.selvaPenge) return window.selvaPenge(oere, true);
    var kr = oere / 100;
    var helt = Math.round(kr * 100) / 100;
    var tekst = (helt % 1 === 0) ? String(helt) : helt.toFixed(2).replace(".", ",");
    return tekst + " kr";
  }

  function retPriser(sec) {
    var dataEl = sec.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.options) return;

    var antalIndex = -1;
    for (var i = 0; i < data.options.length; i++) {
      if (data.options[i].name === "Antal") { antalIndex = i; }
    }
    if (antalIndex === -1) return;

    sec.querySelectorAll("[data-svp-gruppe='antal'] .svp__pakke").forEach(function (btn) {
      var vaerdi = btn.getAttribute("data-svp-vaerdi");
      var v = null;
      for (var j = 0; j < data.variants.length; j++) {
        if (data.variants[j].options && data.variants[j].options[antalIndex] === vaerdi) { v = data.variants[j]; break; }
      }
      if (!v) return;

      var prisEl = btn.querySelector("[data-svp-pakke-pris]");
      var foerEl = btn.querySelector("[data-svp-pakke-foer]");
      var maerkeEl = btn.querySelector("[data-svp-pakke-maerke]");

      var basis = (v.compareAtPrice && v.compareAtPrice > v.price) ? v.compareAtPrice : v.price;
      var basisTekst = (v.compareAtPrice && v.compareAtPrice > v.price) ? (v.compareAtFormatted || formatDkk(v.compareAtPrice)) : (v.priceFormatted || formatDkk(v.price));

      if (prisEl) prisEl.textContent = v.priceFormatted || formatDkk(v.price);
      if (foerEl) {
        if (v.price < basis) { foerEl.textContent = basisTekst; foerEl.hidden = false; }
        else { foerEl.hidden = true; }
      }
      if (maerkeEl) {
        if (v.price < basis) {
          maerkeEl.textContent = "Spar " + Math.round((1 - v.price / basis) * 100) + "%";
          maerkeEl.hidden = false;
        } else {
          maerkeEl.hidden = true;
        }
      }
    });
  }

  function startPrisfix() {
    var sektioner = Array.prototype.slice.call(document.querySelectorAll("section.svp"));
    sektioner.forEach(function (sec) {
      // Har sektionen en koebstype-vaelger, er abonnementet reelt og
      // priserne er allerede rigtige. Lad den vaere.
      if (sec.querySelector("[data-svp-gruppe='koebstype']")) return;

      retPriser(sec);
      // Sektionens egen kode tegner priserne igen ved hvert klik paa en
      // pakke eller haartype, saa vi retter bagefter (samme opgave-koe,
      // derfor er der ingen synlig flimren).
      sec.addEventListener("click", function (ev) {
        if (!ev.target.closest) return;
        if (!ev.target.closest(".svp__pakke, .svp__haartype-knap")) return;
        setTimeout(function () { retPriser(sec); }, 0);
      });
    });
  }

  /* =========================================================
     3) HAARTYPE SKIFTER HOVEDBILLEDET

     FEJL i selva-produkt-koeb: sektionens klik-handler skifter variant,
     pris, trust-linje og knapper — men roerer aldrig galleriet. Klikkede
     kunden "Vegansk", blev hestehaars-packshottet staaende, saa billedet
     viste noget andet end den variant der laa i kurven.

     Varianterne har hvert sit billede i Shopify (packshot pr. haartype),
     saa her hentes produktets egen JSON og hovedbilledet — plus dets
     miniature — skiftes til den valgte haartypes billede. Galleriet
     rendres med "limit: 8", saa variantpackshottene ligger uden for de
     viste billeder; derfor byttes selve src'en paa billede 0 i stedet
     for at hoppe til et indeks der ikke findes i DOM'en.

     Findes der intet variantbillede, ruller den tilbage til det
     oprindelige. Fejler fetch, sker der ingenting — galleriet opfoerer
     sig praecis som foer.
     ========================================================= */
  function byggBilledUrl(src, bredde) {
    var u = src.indexOf("//") === 0 ? "https:" + src : src;
    return u + (u.indexOf("?") === -1 ? "?" : "&") + "width=" + bredde;
  }

  function startHaartypeBillede() {
    var sektioner = Array.prototype.slice.call(document.querySelectorAll("section.svp"));
    if (!sektioner.length) return;

    sektioner.forEach(function (sec) {
      var gruppe = sec.querySelector("[data-svp-gruppe='hartype']");
      if (!gruppe) return;

      var hovedbillede = sec.querySelector("[data-svp-billede='0']");
      if (!hovedbillede) return;
      var miniatureKnap = sec.querySelector("[data-svp-vis='0']");
      var miniature = miniatureKnap ? miniatureKnap.querySelector("img") : null;

      // Husk udgangspunktet, saa der altid kan rulles tilbage.
      if (!hovedbillede.getAttribute("data-svp-standard-src")) {
        hovedbillede.setAttribute("data-svp-standard-src", hovedbillede.getAttribute("src") || "");
        hovedbillede.setAttribute("data-svp-standard-srcset", hovedbillede.getAttribute("srcset") || "");
        if (miniature) miniature.setAttribute("data-svp-standard-src", miniature.getAttribute("src") || "");
      }

      var kort = null; // haartype i lowercase -> billed-src

      function saetBillede() {
        if (!kort) return;

        var valgt = gruppe.querySelector(".er-valgt[data-svp-vaerdi]");
        var vaerdi = valgt ? (valgt.getAttribute("data-svp-vaerdi") || "").toLowerCase() : "";
        var src = kort[vaerdi];

        if (src) {
          hovedbillede.setAttribute("src", byggBilledUrl(src, 1200));
          hovedbillede.setAttribute(
            "srcset",
            byggBilledUrl(src, 700) + " 700w, " + byggBilledUrl(src, 1200) + " 1200w, " + byggBilledUrl(src, 1600) + " 1600w"
          );
          if (miniature) miniature.setAttribute("src", byggBilledUrl(src, 200));
        } else {
          hovedbillede.setAttribute("src", hovedbillede.getAttribute("data-svp-standard-src") || "");
          var std = hovedbillede.getAttribute("data-svp-standard-srcset");
          if (std) hovedbillede.setAttribute("srcset", std);
          if (miniature) {
            var stdMini = miniature.getAttribute("data-svp-standard-src");
            if (stdMini) miniature.setAttribute("src", stdMini);
          }
        }

        // Skift altid tilbage til billede 0, saa kunden ser det billede
        // der lige er blevet udskiftet — ikke en slide laengere inde.
        sec.querySelectorAll("[data-svp-billede]").forEach(function (img) {
          img.classList.toggle("er-aktiv", img.getAttribute("data-svp-billede") === "0");
        });
        sec.querySelectorAll("[data-svp-vis]").forEach(function (k) {
          k.classList.toggle("er-aktiv", k.getAttribute("data-svp-vis") === "0");
        });
      }

      var sti = location.pathname.replace(/\/+$/, "");
      fetch(sti + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants || !p.options) return;

          var idx = -1;
          for (var i = 0; i < p.options.length; i++) {
            var navn = typeof p.options[i] === "string" ? p.options[i] : p.options[i].name;
            if (navn === "Hårtype") { idx = i; break; }
          }
          if (idx === -1) return;

          kort = {};
          p.variants.forEach(function (v) {
            var vaerdi = (v.options && v.options[idx] ? v.options[idx] : "").toLowerCase();
            if (!vaerdi || kort[vaerdi]) return;
            if (v.featured_image && v.featured_image.src) kort[vaerdi] = v.featured_image.src;
          });

          saetBillede();
        })
        .catch(function () {});

      // Sektionens egen handler saetter "er-valgt" paa klik. Vi laeser
      // resultatet bagefter i samme opgave-koe.
      gruppe.addEventListener("click", function (ev) {
        if (!ev.target.closest) return;
        if (!ev.target.closest("[data-svp-vaerdi]")) return;
        setTimeout(saetBillede, 0);
      });
    });
  }

  /* =========================================================
     4) INDLAES GALLERI-NAVIGATIONEN

     Pilene og swipe ligger i assets/selva-galleri.js, saa den kode kan
     rettes uden at roere denne fil. Den indlaeses kun naar der faktisk
     er en koebsboks paa siden.
     ========================================================= */
  function startGalleriNav() {
    if (!document.querySelector("section.svp")) return;
    if (document.getElementById("svp-galleri-js")) return;
    var kilde = null;
    var alle = document.querySelectorAll('script[src*="selva-polish"]');
    if (alle.length) kilde = alle[alle.length - 1].src;
    if (!kilde) return;
    var s = document.createElement("script");
    s.id = "svp-galleri-js";
    s.defer = true;
    s.src = kilde.replace(/selva-polish\.js/, "selva-galleri.js");
    document.head.appendChild(s);
  }

  function start() {
    try { startPrisfix(); } catch (e) {}
    try { startHaartypeBillede(); } catch (e) {}
    try { startGalleriNav(); } catch (e) {}
    startReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();